import { render, staticRenderFns } from "./CourseTestCard.vue?vue&type=template&id=081942d5&scoped=true"
import script from "./CourseTestCard.vue?vue&type=script&lang=ts"
export * from "./CourseTestCard.vue?vue&type=script&lang=ts"
import style0 from "./CourseTestCard.vue?vue&type=style&index=0&id=081942d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081942d5",
  null
  
)

export default component.exports